<template>
  <div>
    <div class="accordion" role="tablist">
      <div class="widget-header border-bottom">
        <div class="m-0 h4 d-flex" v-b-toggle="`pbxCall-accordion-${data.id}`">
          <p class="mb-0 mx-auto text-center">
            {{ formatDateAssigned(data.created_at) }}
          </p>
          <template>
            <feather-icon
              :icon="isCollapseOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="24"
            />
          </template>
        </div>
      </div>
      <b-collapse
        :id="`pbxCall-accordion-${data.id}`"
        :accordion="`pbxCall-accordion-${data.id}`"
        role="tabpanel"
        :visible="false"
        v-model="isCollapseOpen"
      >
        <div>
          <table class="table">
            <tr>
              <th>ID</th>
              <td>{{ data.id }}</td>
            </tr>
            <tr>
              <th>SessionId</th>
              <td>{{ data.id_session }}</td>
            </tr>
            <tr>
              <th>{{ $t("grid.slots.info.sip_call.state") }}</th>
              <td>{{ data.status }}</td>
            </tr>
            <tr>
              <th>{{ $t("grid.slots.info.sip_call.from") }}</th>
              <td>{{ device_unit_user_calling_party_number }}</td>
            </tr>
            <tr>
              <th>{{ $t("grid.slots.info.sip_call.to") }}</th>
              <td>{{ device_unit_user_remote_party_number }}</td>
            </tr>
            <tr>
              <th>{{ $t("grid.slots.info.sip_call.origin_date") }}</th>
              <td>{{ formatDateAssigned(data.created_at) }}</td>
            </tr>
            <tr
              v-if="data.recording_url && $can('read_record_call', 'SipCall')"
            >
              <th>{{ $t("grid.slots.info.sip_call.audio_record") }}</th>
              <td>
                <audio
                  controls
                  v-if="data.recording_url"
                  :controlsList="
                    $can('download', 'PbxCall') ? 'download' : 'nodownload'
                  "
                >
                  <source :src="data.recording_url" />
                  Your browser does not support the audio element.
                </audio>
              </td>
            </tr>
          </table>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import moment from "moment-timezone";
import { EventBus } from "@/libs/event-bus";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      isCollapseOpen: true,
      device_unit_user_calling_party_number:
        this.$props.data.device.find((device) => device.pivot.rol === "caller")
          .extension || null,
      device_unit_user_remote_party_number:
        this.$props.data.device.find(
          (device) => device.pivot.rol === "receiver"
        ).extension || null,
    };
  },
  computed: {},
  methods: {
    makeCall(data) {
      EventBus.emit(`call_device`, { id: data.callingPartyNumber });
    },
    formatDateAssigned(value) {
      const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
      return formattedDate;
    },
    getDeviceUnitUser(device_id) {
      let unit_user = device_id;
      store
        .dispatch("pbx_device/getCallerName", device_id)
        .then((response) => {
          console.log({ response });
          unit_user += " - " + response;
        })
        .catch((e) => {
          console.log({ e });
        });
      return unit_user;
    },
    setDeviceUnitUserCallingPartyNumber() {
      let unit_user = this.$props.data.device.find(
        (device) => device.pivot.rol === "caller"
      ).extension;
      store
        .dispatch("pbx_device/getCallerName", unit_user)
        .then((response) => {
          unit_user += " - " + response;
          this.device_unit_user_calling_party_number = unit_user;
        })
        .catch((e) => {
          console.log({ e });
        });
    },
    setDeviceUnitUserRemotePartyNumber() {
      let unit_user = this.$props.data.device.find(
        (device) => device.pivot.rol === "receiver"
      );
      store
        .dispatch("pbx_device/getCallerName", {
          device_id: this.$props.data.remotePartyNumber,
        })
        .then((response) => {
          unit_user += " - " + response;
          this.device_unit_user_remote_party_number = unit_user;
        })
        .catch((e) => {
          console.log({ e });
        });
    },
    showMessage(title, msg, variant = "success") {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title,
          variant,
          icon: "BellIcon",
          text: msg,
          timeout: 5000,
        },
      });
    },
  },
  mounted() {
    this.setDeviceUnitUserCallingPartyNumber();
    this.setDeviceUnitUserRemotePartyNumber();
  },
};
</script>

<style></style>
